<div class="carousel flex gap-x-15px overflow-x-scroll w-full">
    @for (feature of featuresContent; let i = $index; track feature.title) {
        <button
            #featureSlide
            [class]="
                [currentIndex() === i ? 'button-active-blue-gradient' : 'button-white-active-gradient'] | joinClassNames
            "
            (click)="onClick(i)"
        >
            {{ feature.title }}
        </button>
    }
</div>
